var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"infoBlock",class:("is-" + _vm.type)},[_vm._t("default"),_c('b-icon',{staticClass:"infoBlock__icon",attrs:{"icon":_vm.icon,"size":"is-small"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }